import { useEffect, useRef } from 'react';

/**
 * نغمة تتكرّر ما دام الشرط قائماً.
 *
 * المكالمة كانت صامتة تماماً حتى يتكلّم أحد: لا رنين عند المذيع، ولا
 * نغمة انتظار عند المتصل. فيبدو للطرفين أن شيئاً لا يعمل، ويُظنّ العطل
 * في الصوت وهو في غيابه.
 *
 * والصوت يبدأ بإيماءة المستخدم (نقرة الاتصال أو الرد)، فلا تمنعه
 * سياسة التشغيل التلقائي في المتصفّح.
 */
export function useRingtone(src, playing, { volume = 0.5 } = {}) {
  const audioRef = useRef(null);

  useEffect(() => {
    if (!playing) {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
        audioRef.current = null;
      }
      return;
    }

    const a = new Audio(src);
    a.loop = true;
    a.volume = volume;
    audioRef.current = a;

    const playPromise = a.play();
    if (playPromise) {
      playPromise.catch(() => {
        const unlock = () => {
          if (audioRef.current === a) {
            a.play().catch(() => {});
          }
        };
        window.addEventListener('click', unlock, { once: true });
        window.addEventListener('touchstart', unlock, { once: true });
      });
    }

    return () => {
      try {
        a.pause();
        a.currentTime = 0;
      } catch {
        // عنصر تُخلّص منه أصلاً
      }
      if (audioRef.current === a) audioRef.current = null;
    };
  }, [src, playing, volume]);
}
